var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"roof",style:({ width: _vm.roofWidth + 'px' })},[_c('div',{staticClass:"upper-roof"}),_vm._v(" "),_c('div',{staticClass:"mid-roof"}),_vm._v(" "),_c('div',{staticClass:"lower-roof"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45b2176b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Buildings/Vertical/BuildingComponents/Roof.vue
// module id = null
// module chunks = 